<template>
    <div ref="container" class="flex-shrink-0">
        <div ref="trigger">
            <div v-if="trigger == 'longclick'" v-longclick="abrir"><slot v-bind="{ open: aberto }"></slot></div>
            <div v-else @click="abrir()"><slot v-bind="{ open: aberto }"></slot></div>
        </div>

        <div
            ref="menu"
            class="
                absolute
                min-w-[150px]
                z-50
                bg-white
                dark:bg-dark-900
                dark:text-gray-300
                rounded
                py-2
                ring-1 ring-black ring-opacity-10
                shadow-lg
                transition-all
                transform
                duration-300
            "
            :class="[aberto ? 'opacity-0' : 'hidden', className]"
            :style="'width: ' + width"
        >
            <slot name="menu"></slot>
        </div>
    </div>
</template>

<script>
import * as Minipopper from '@App/Lib/Minipopper'
import { findParent } from '@App/Utils/Dom'

export default {
    props: ['posição', 'width', 'className', 'trigger'],
    data() {
        return {
            aberto: false,
        }
    },
    mounted() {
        this.$refs.menu.parentElement.removeChild(this.$refs.menu)
        this.$menu = this.$refs.menu
    },
    watch: {
        aberto(flag) {
            if (flag) {
                document.body.appendChild(this.$refs.menu)
                this.$nextTick(() => {
                    Minipopper.atualizarPosição(this.$refs.trigger, this.$refs.menu, this.posição)

                    requestAnimationFrame(() => {
                        this.$refs.menu.classList.remove('opacity-0')
                        this.$refs.menu.classList.add('opacity-100')
                    })
                })

                let clickHandler = (ev) => {
                    if (!this.$refs.menu && this.$menu) {
                        document.removeEventListener('click', clickHandler)
                        document.body.removeChild(this.$menu)
                        this.aberto = false
                        return
                    }

                    if (this.$refs.menu.contains(ev.target)) {
                        let shouldClose = findParent(ev.target, (p) => p.hasAttribute('close-dropdown'))

                        if (shouldClose) {
                            setTimeout(() => {
                                this.aberto = false
                            })
                            document.removeEventListener('click', clickHandler)
                        }
                    } else {
                        this.aberto = false
                        document.removeEventListener('click', clickHandler)
                    }
                }

                if (this.trigger == 'longclick') {
                    document.addEventListener(
                        'mouseup',
                        () => {
                            setTimeout(() => {
                                document.addEventListener('click', clickHandler)
                            })
                        },
                        { once: true }
                    )
                } else {
                    setTimeout(() => {
                        document.addEventListener('click', clickHandler)
                    })
                }
            } else if (document.body.contains(this.$refs.menu)) {
                document.body.removeChild(this.$refs.menu)
            }
        },
    },
    methods: {
        abrir() {
            if (!this.aberto) this.aberto = true
        },
    },
}
</script>
